import { IInstallationMenuItem, IInstallationParentFlat } from "../../services/api-services/installations/response/installation-menu-item.response";
import { IProductConfigurationHeaderResponse } from "../../services/api-services/product-configuration/models/product-configuration-headers.model";
import { InstallationMenuItemNew } from "../../shared/sidebar/sidebar-installations-menu/models/installation-menu-item.model";
import { IInstallationState } from "./interfaces/installation-state.interface";

export const getLatestInstallationSuccessHandler = (state: IInstallationState, action: { installations: InstallationMenuItemNew[] }): IInstallationState =>
    ({ ...state, latestInstallations: action.installations, latestInstallationsFailedError: undefined, latestInstallationsIsLoading: false });

export const getLatestInstallationFailedHandler = function (state: IInstallationState, action: { error: string }): IInstallationState {
    return {
        ...state,
        latestInstallationsIsLoading: false,
        latestInstallationsFailedError: action.error
    }
};

export const getActiveInstallationDetailsSuccessHandler = (state: IInstallationState, action: { installation: InstallationMenuItemNew }): IInstallationState => {
    const getTopGroup = (installation: IInstallationMenuItem): IInstallationParentFlat | undefined => {
        let current: IInstallationParentFlat | undefined = installation.parent ?? {
            refCode: installation.refCode,
            name: installation.name,
            type: installation.type,
            urlPrefix: installation.urlPrefix ?? ''
        };

        while (current?.parent) {
            current = current.parent;
        }
        return current; // last parent (root)
    }
    // Get the top group
    var topGroup = getTopGroup(action.installation);
    return { ...state, activeInstallationDetails: action.installation, activeInstallationDetailsFailedError: undefined, replacedActiveInstallationDetails: undefined, replacedActiveInstallationInfo: undefined, selectedTopGroup: topGroup, selectedTopGroupRefCode: topGroup?.refCode, resetSelectedTopGroup: topGroup, resetSelectedTopGroupRefCode: topGroup?.refCode }
};

/**
 * Puts back the details the request replaced. A failed switch cancels the navigation, so the page still on
 * screen is the previous installation's - without its details it would render empty and refuse every link
 * inside it until a reload. On a first load there is nothing to put back and the details stay undefined
 * (InstallationSelectors.selectStartupLoadFailed).
 */
export const getActiveInstallationDetailsFailedHandler = (state: IInstallationState, action: { error: string }): IInstallationState =>
    ({
        ...state,
        activeInstallationDetails: state.replacedActiveInstallationDetails,
        activeInstallationInfo: state.replacedActiveInstallationInfo,
        replacedActiveInstallationDetails: undefined,
        replacedActiveInstallationInfo: undefined,
        activeInstallationDetailsFailedError: action.error
    });

export const setProductConfigurationHeadersHandler = (state: IInstallationState, action: { headers: IProductConfigurationHeaderResponse[] | undefined | null }): IInstallationState =>
    ({ ...state, activeInstallationInfo: { productConfigurationHeaders: action.headers } });

